import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./deleteIconButton.html";
import { IS_DEVELOPMENT } from '../../../config';
class DeleteIconButton extends LightningElement {
  constructor(...args) {
    super(...args);
    /** @type {string} */
    this.description = void 0;
    /** @type {() => void} */
    this.handleClick = void 0;
    this.disabled = false;
  }
  connectedCallback() {
    if (IS_DEVELOPMENT && !this.handleClick) {
      throw new Error("DeleteButtonIcon must have a 'handleClick' property");
    }
  }

  /**
   * @param {InputEvent} event
   */
  clicked(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.disabled) {
      return;
    }
    this.handleClick?.();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(DeleteIconButton, {
  publicProps: {
    description: {
      config: 0
    },
    handleClick: {
      config: 0
    },
    disabled: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(DeleteIconButton, {
  tmpl: _tmpl,
  sel: "appx-delete-icon-button",
  apiVersion: 62
});
export default __lwc_component_class_internal;